export default "__VITE_ASSET___KdMI2Nv__"